import { render, staticRenderFns } from "./DevSandBox.vue?vue&type=template&id=4c352e2e&scoped=true"
import script from "./DevSandBox.vue?vue&type=script&lang=js"
export * from "./DevSandBox.vue?vue&type=script&lang=js"
import style0 from "./DevSandBox.vue?vue&type=style&index=0&id=4c352e2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c352e2e",
  null
  
)

export default component.exports